<div class="script-content">
  <ngx-codemirror
    [(ngModel)]="value"
    [options]="options"
    (ngModelChange)="onChange($event)"
  />
</div>
